import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import { encryptData, decryptData, secretKey } from "../store/Encrypt";
import "./Login.css";

const renderModernInput = ({
  input,
  label,
  type,
  meta: { touched, error },
  placeholder,
}) => (
  <div className="login-field">
    <label>{label}</label>
    <input
      {...input}
      type={type}
      placeholder={placeholder || label}
      className={touched && error ? "error" : ""}
    />
    {touched && error && <span className="error-text">{error}</span>}
  </div>
);
const Login = (props) => {
  const { handleSubmit } = props;
  const [serverRes, setserverRes] = useState("");
  const [alertColor, setalertColor] = useState("");
  const [isTotpStep, setIsTotpStep] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [pendingEmail, setPendingEmail] = useState("");
  const [totpSecret, setTotpSecret] = useState("");
  const [totpAuthUrl, setTotpAuthUrl] = useState("");
  const [hasTotpEnabled, setHasTotpEnabled] = useState(false);
  const [showTotpEnrollment, setShowTotpEnrollment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const submitToApi = (values) => {
    setserverRes("");
    setIsLoading(true);
    axios
      .post(BaseUrl + "checkBackOfficeUser", values)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errCode === 121) {
          setserverRes(res.data.errMessage);
          setalertColor("red");
          setTimeout(() => {
            setserverRes("");
            setalertColor("");
          }, 5000);
        } else if (res.data.errCode === 200) {
          const email = values.email;
          setPendingEmail(email);
          setIsTotpStep(false);
          setOtpValue("");
          setTotpSecret("");
          setTotpAuthUrl("");
          const enabled = !!res.data.totpEnabled;
          setHasTotpEnabled(enabled);
          if (enabled) {
            setShowTotpEnrollment(false);
            setserverRes("Enter the 6-digit code from your authenticator app.");
            setalertColor("blue");
            setIsTotpStep(true);
          } else {
            enableTotp(email);
          }
        } else {
          setserverRes("Login failed. Please try again.");
          setalertColor("red");
        }
      })
      .catch((error) => {
        console.log(error);
        setserverRes("Network error. Please try again.");
        setalertColor("red");
      })
      .finally(() => setIsLoading(false));
  };

  const resetToLogin = () => {
    setIsTotpStep(false);
    setOtpValue("");
    setPendingEmail("");
    setTotpSecret("");
    setTotpAuthUrl("");
    setShowTotpEnrollment(false);
    setserverRes("");
    setalertColor("");
  };

  const enableTotp = (emailArg) => {
    setIsLoading(true);
    setserverRes("");
    axios
      .post(BaseUrl + "enableTotp", { email: emailArg || pendingEmail })
      .then((res) => {
        const { totpSecret: secret, totpAuthUrl: authUrl, errCode } = res.data || {};

        if (errCode === 200) {
          // If secret is returned, show enrollment; otherwise, just prompt for TOTP
          if (secret && authUrl) {
            setTotpSecret(secret);
            setTotpAuthUrl(authUrl);
            setShowTotpEnrollment(true);
            setserverRes("Scan the QR or use the secret, then enter the 6-digit code.");
          } else {
            setTotpSecret("");
            setTotpAuthUrl("");
            setShowTotpEnrollment(false);
            setserverRes("Enter the 6-digit code from your authenticator app.");
          }
          setalertColor("blue");
          setIsTotpStep(true);
        } else {
          setserverRes("Unable to enable Google Authenticator.");
          setalertColor("red");
        }
      })
      .catch((error) => {
        console.log(error);
        setserverRes("Network error. Please try again.");
        setalertColor("red");
      })
      .finally(() => setIsLoading(false));
  };

  const verifyTotp = () => {
    if (!otpValue || !pendingEmail) {
      setserverRes("Please enter the TOTP code.");
      setalertColor("red");
      return;
    }
    setIsLoading(true);
    setserverRes("");
    axios
      .post(BaseUrl + "verifyTotp", {
        email: pendingEmail,
        otp: otpValue,
      })
      .then((res) => {
        if (res.data?.errCode === 200) {
          const encryptedJSON = encryptData(res.data, secretKey);
          Cookies.set("authTokens", encryptedJSON, { expires: 7 });
          navigate("/dashboard");
        } else {
          setserverRes("Invalid code. Please try again.");
          setalertColor("red");
        }
      })
      .catch((error) => {
        console.log(error);
        setserverRes("Network error. Please try again.");
        setalertColor("red");
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <div className="login-hero">
      <div className="login-card">
        <div className="login-header">
          <h1>SS Business</h1>
          <p>Back Office Management System</p>
        </div>

        {serverRes && (
          <div className={`login-alert ${alertColor === "red" ? "error" : ""}`}>
            {serverRes}
          </div>
        )}

        {!isTotpStep && (
          <div className="login-body">
            <h2>Welcome Back</h2>
            <p className="muted">Sign in to access your dashboard</p>
            <form
              onSubmit={handleSubmit((values) => submitToApi({ ...values }))}
              className="login-form"
            >
              <Field
                name="email"
                label="Email Address"
                type="email"
                component={renderModernInput}
                placeholder="Enter your email"
              />
              <Field
                name="userPassword"
                label="Password"
                type="password"
                component={renderModernInput}
                placeholder="Enter your password"
              />
              <button type="submit" className="login-btn" disabled={isLoading}>
                {isLoading ? "Please wait..." : "Sign In"}
              </button>
            </form>
          </div>
        )}

        {isTotpStep && (
          <div className="login-body">
            <h2>Google Authenticator</h2>
            <p className="muted">
              {showTotpEnrollment
                ? "Scan the QR or use the secret. Then enter the 6-digit code."
                : "Enter the 6-digit code from your authenticator app."}
            </p>
            {showTotpEnrollment && totpAuthUrl && (
              <div className="login-qr-box">
                <img
                  src={`https://quickchart.io/qr?text=${encodeURIComponent(
                    totpAuthUrl
                  )}&size=200`}
                  alt="TOTP QR"
                  className="login-qr-img"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
                <a href={totpAuthUrl} target="_blank" rel="noreferrer">
                  Open QR / Enrollment Link
                </a>
              </div>
            )}
            {showTotpEnrollment && totpSecret && (
              <div className="login-secret-box">
                <label>Secret: </label>
                <code>{totpSecret}</code>
              </div>
            )}
            <div className="login-form">
              <div className="login-field">
                <label>TOTP</label>
                <input
                  type="text"
                  value={otpValue}
                  onChange={(e) => setOtpValue(e.target.value)}
                  placeholder="Enter 6-digit code"
                />
              </div>
              <div className="otp-actions">
                <button
                  type="button"
                  className="login-btn"
                  onClick={verifyTotp}
                  disabled={isLoading}
                >
                  {isLoading ? "Verifying..." : "Verify TOTP"}
                </button>
                <button
                  type="button"
                  className="login-btn secondary"
                  onClick={resetToLogin}
                  disabled={isLoading}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="login-footer">
          <p>© 2024 SS Business. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default reduxForm({
  form: "Login",
})(Login);
